import { type IUsdWithdrawRequestContext, UsdWithdrawRequestContext } from 'BreetComponents';
import { useContext } from 'react';

export const useUsdWithdrawRequestContext = (): IUsdWithdrawRequestContext => {
	const fiatWithdrawRequestContext = useContext(UsdWithdrawRequestContext);

	if (!fiatWithdrawRequestContext) {
		throw new Error('useUsdWithdrawRequestContext must be used within a UsdWithdrawRequestProvider');
	}

	return fiatWithdrawRequestContext;
};
